import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import { hasFeatureFlags } from 'utils/features';

class CustomGroupsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  toggleExpand() {
    this.setState(state => ({
      expanded: !state.expanded,
    }));
    this.props.updateActiveGroup(this.props.group.id);
    this.props.updateMyOrganization(false);

    if (this.props.groupsListVisible) {
      this.props.toggleGroupsList();
    }
  }

  render() {
    const hasUnificationFeatureFlag = hasFeatureFlags([
      'readiness-enable-unification',
    ]);
    let children = null;
    const { group, activeGroup, updateActiveGroup } = this.props;
    const iconStyle = classNames({
      'NestedList-icon': true,
      'NestedList-icon--rotated': this.state.expanded,
    });

    const liStyle = classNames(
      'NestedList-item',
      'CustomColor--borderColorLeft',
      'NestedList--hoverStyles',
      {
        'NestedList-item--active':
          activeGroup === group.id && !hasUnificationFeatureFlag,
        'c-color-primary':
          Number(activeGroup) === Number(group.id) && hasUnificationFeatureFlag,
        'fw-b': activeGroup === group.id,
      },
    );

    if (group.children) {
      children = group.children.map(child => (
        <CustomGroupsList
          group={child}
          key={child.id}
          activeGroup={activeGroup}
          updateActiveGroup={updateActiveGroup}
          updateMyOrganization={this.props.updateMyOrganization}
        />
      ));
    }

    return (
      <ul className="NestedList">
        <li className={liStyle}>
          {group.children.length > 0 && (
            <span className={iconStyle}>
              <Icon name="triangle_down" className="Icon--small c-brand-gray" />
            </span>
          )}{' '}
          <span
            tabIndex="0"
            role="button"
            onClick={this.toggleExpand}
            onKeyDown={e => e.key === 'Enter' && this.toggleExpand()}
          >
            <div
              className={classNames({
                'NestedList-item--unify--active fw-b':
                  activeGroup === group.id && hasUnificationFeatureFlag,
              })}
            />
            {group.name}
          </span>
        </li>
        {children && this.state.expanded && <li>{children}</li>}
      </ul>
    );
  }
}

export default CustomGroupsList;
